import React, { Component} from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ScrollToTop from './resources/views/partials/ScrollToTop'
import './resources/scss/App.scss';
import Home from './resources/views/pages/home'
import Project from './resources/views/pages/project'
import NotFound from './resources/views/pages/404'
import Loader from './resources/views/partials/loader'
import List from './resources/views/ToDoList/List'

import ReactGA from 'react-ga'
ReactGA.initialize('UA-99491884-1');
ReactGA.pageview(window.location.pathname + window.location.search);

const Footer = () => {
  return (
    <footer>
      <span>&copy; {new Date().getFullYear()} atarapacky. All rights reserved.</span>
    </footer>
  )
}

class App extends Component {

  constructor(props){
    super(props);
    this.state = { 
      data: [] ,
      isLoading: true,
      redirectTo404: false,
      error: ''
    }
  }
  
  async componentDidMount() {
    const response = await fetch('data.json', {
      headers : { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }).then(res => (res.json()))

    Promise.all([ response ])
    .then(
      this.setState({
        data: response,
        isLoading: false
			})
    ).catch(error => {
      this.setState({
        redirectTo404: true,
        isLoading: false,
        error
      })
    })
  }

  render() {
    return (
      <div>
        { this.state.isLoading ? <Loader /> : (
          <Router>
            <ScrollToTop>
            <Switch>
              <Route path="/todo" render={() => <List />} />
              <Route 
                path="/:slug" 
                render={props => {
                  let projectData, prevSlug, nextSlug = ''
                  this.state.data.projects.forEach((project, k) => {
                    if (project.slug === props.match.params.slug) {
                      projectData = project
                      if (k === 0) {
                        prevSlug = this.state.data.projects[Object.keys(this.state.data.projects).length - 1].slug
                        nextSlug = this.state.data.projects[1].slug
                      } else if (k === (Object.keys(this.state.data.projects).length) - 1) {
                        prevSlug = this.state.data.projects[k - 1].slug
                        nextSlug = this.state.data.projects[0].slug
                      } else {
                        prevSlug = this.state.data.projects[k - 1].slug
                        nextSlug = this.state.data.projects[k + 1].slug
                      }
                    }
                  })
                  if (projectData) {
                    return (
                      <Project
                        project={projectData} 
                        prevSlug={prevSlug}
                        nextSlug={nextSlug}
                      />
                    )
                  } else {
                    return <NotFound />
                  }
                }}
              />
              <Route 
                path="/" 
                render={() => 
                  <Home 
                    bio={this.state.data.description}
                    data={this.state.data.projects} 
                  />
                }
              />
          </Switch>
          </ScrollToTop>            
          </Router>
        )}
        <Footer />
      </div>
    )
  }
}

export default App
